<template>
  <div class="active-schools">
    <h1 class="text-center my-7">ناظرین</h1>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <NavigationComponent />
      </v-col>
      <v-col cols="12" md="9" class="px-2 py-0">
        <v-row>
          <v-col cols="12">
            <v-card class="elevation-0 mb-5 pa-5">
              <h5>اضافه کردن ناظر جدید</h5>
              <v-form
                v-model="valid"
                @submit.prevent="findUser"
                class="text-center"
              >
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="mobile"
                      :rules="mobileRules"
                      autocomplete="off"
                      label="شماره همراه کاربر"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      dense
                      :items="stateItems"
                      v-model="state"
                      :rules="stateRules"
                      item-text="name"
                      item-value="_id"
                      label="استان"
                      required
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      dense
                      multiple
                      :items="cityItems"
                      v-model="cities"
                      :rules="cityRules"
                      item-text="name"
                      item-value="_id"
                      label="شهر"
                      chips
                      required
                    >
                      <template v-slot:prepend-item>
                        <v-list-item ripple @click="toggle">
                          <v-list-item-action>
                            <v-icon
                              :color="
                                cities.length > 0 ? 'indigo darken-4' : ''
                              "
                            >
                              {{ icon }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title> انتخاب همه </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      :loading="loading"
                      :disabled="!valid || loading"
                      depressed
                      block
                      color="primary"
                      type="submit"
                    >
                      جستجو
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-col>
          <v-col v-if="user" cols="12">
            <v-card class="elevation-0 mb-5 pa-5">
              <v-list-item>
                <v-list-item-content class="text-center">
                  <div class="mb-4">
                    {{ user.username }}
                  </div>
                  <v-list-item-title class="headline mb-4">
                    {{ user.firstname + " " + user.lastname }}
                  </v-list-item-title>
                  <v-list-item-title>
                    نوع کاربر: {{ user.type }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-card-actions>
                <v-btn
                  block
                  rounded
                  depressed
                  color="success"
                  @click="setSupervisor(user._id)"
                >
                  تبدیل کاربر به ناظر
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <h3 class="mb-5">لیست ناظر ها</h3>
        <v-data-table
          :headers="headers"
          :items="supervisors"
          :items-per-page="10"
          show-expand
          single-expand
          item-key="_id"
        >
          <template v-slot:[`item._id`]="{ item }">
            <div class="d-flex justify-center">
              <v-btn
                depressed
                small
                color="error"
                class="mr-2"
                @click="disableSueprvisor(item._id)"
              >
                غیر فعال کردن حالت نظارت
              </v-btn>
            </div>
          </template>

          <template v-slot:[`item.requestDate`]="{ item }">
            <persian-date :date="item.requestDate" />
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-chip-group column>
                <v-chip v-for="city in item.superviosrCities" :key="city._id">
                  {{ city.name }}
                </v-chip>
              </v-chip-group>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NavigationComponent from "./_Navigation.vue";
export default {
  name: "agents-component",
  components: {
    NavigationComponent
  },
  data: () => {
    return {
      valid: true,
      loading: false,
      mobile: "",
      mobileRules: [
        (v) => !!v || "لطفا تلفن همراه خود را وارد نمایید",
        (v) => (v && v.length == 11) || "تلفن همراه را به درستی وارد نمایید"
      ],
      state: "",
      stateRules: [(v) => !!v || "استان را انتخاب نمایید"],
      stateItems: [],
      cities: [],
      cityRules: [(v) => !!v || "شهر را انتخاب نمایید"],
      cityItems: [],
      user: null,
      supervisors: [],
      headers: [
        { text: "نام", value: "firstname", align: "center" },
        { text: "نام خانوادگی", value: "lastname", align: "center" },
        { text: "شماره همراه", value: "username", align: "center" },
        { text: "عملیات", value: "_id", align: "center" }
      ]
    };
  },
  computed: {
    icon() {
      if (this.cities.length === this.cityItems.length) return "mdi-close-box";
      if (this.cities.length > 0 && this.cities.length != this.cityItems.length)
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  watch: {
    state(val) {
      this.city = "";
      this.handleGetCity(val);
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$api.get("/user/supervisors").then((res) => {
        this.supervisors = res.data.users;
      });
      this.$api.get("/states").then((res) => {
        const states = res.data.states;
        states.forEach((element) => {
          this.stateItems.push(element);
        });
        this.loading = false;
      });
    },
    handleGetCity(id) {
      this.loading = true;
      this.cityItems = [];
      this.$api.get("/cities/" + id).then((res) => {
        const cities = res.data.cities;
        cities.forEach((element) => {
          this.cityItems.push(element);
        });
        this.loading = false;
      });
    },
    toggle() {
      this.$nextTick(() => {
        if (this.cities.length === this.cityItems.length) {
          this.cities = [];
        } else {
          this.cityItems.forEach((element) => {
            this.cities.push(element._id);
          });
        }
      });
    },
    findUser() {
      this.$api
        .post("/user/getbymobile", {
          mobile: this.mobile
        })
        .then((res) => {
          this.user = res.data.user;
        });
    },
    setSupervisor(id) {
      this.$api
        .post("/user/setSupervisor", {
          user: id,
          cities: this.cities
        })
        .then(() => {
          this.getData();
          this.user = null;
          this.mobile = "";
          this.state = "";
          this.cities = [];
        });
    },
    disableSueprvisor(id) {
      this.$api
        .post("/user/setDefault", {
          user: id
        })
        .then(() => {
          this.getData();
        });
    }
  }
};
</script>
<style>
.v-select.v-input--dense .v-chip {
  margin: 4px;
}
</style>
